module.exports = __webpack_public_path__ + "media/images/sample_img05-8426498833885bed7ef73564d73b5984.png";